<template>
    <div class="container not_found_container">
        Sorry, the page could not be found
    </div>
</template>

<script>
    export default {
        name: "index"
    }
</script>

<style scoped>

</style>